import React, { Component, createContext } from 'react';
import PropTypes from 'prop-types';

const StateContext = createContext();

export const StateConsumer = StateContext.Consumer;

export default class State extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  state = {
    menuOpen: false,
  };

  toggleMenu = () => {
    const { menuOpen } = this.state;
    this.setState({ menuOpen: !menuOpen });
  };

  render() {
    const { children } = this.props;
    const { menuOpen } = this.state;
    const state = { menuOpen };
    const actions = { toggleMenu: this.toggleMenu };
    return <StateContext.Provider value={{ state, actions }}>{children}</StateContext.Provider>;
  }
}
